import { useEffect } from 'react';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

/**
 * [useBodyScrollLock] locks the body from scrolling besides the targeted element
 * @param isFocused - locks the body from scrolling when isFocused
 * @param ref - target element that you want to persist scrolling
 */
export const useBodyScrollLock = (isFocused, ref) => {
  useEffect(() => {
    if (isFocused && ref?.current) {
      disableBodyScroll(ref?.current);
    }

    return () => clearAllBodyScrollLocks();
  }, [isFocused, ref]);
};
